import { FoodPreference, Gender, Level, ProgramType } from 'fitbeat.models';
import { CardioOrResistance } from '../../entities/exercise/';

export const mappedGoal = new Map<string, ProgramType>([
  ['Muscle & Strength', ProgramType.GainMuscleAndStrengthGoal],
  ['Lean & Fit', ProgramType.GetLeanAndFitGoal],
  ['All-Rounder', ProgramType.GetStrongAndFitGoal],
  ['Mobility & Tone', ProgramType.MobilityAndTone],
  ['Muscle & Shred', ProgramType.MuscleAndShred],
]);

export const mappedLevel = new Map<string, Level>([
  ['Basic', Level.Beginner],
  ['Intermediate', Level.Basic],
  ['Advanced', Level.Intermediate],
]);

export const mappedGender = new Map<string, Gender>([
  ['Male', Gender.Male],
  ['Female', Gender.Female],
  ['Other', Gender.Other],
]);

export const mappedFoodPreference = new Map<string, FoodPreference>([
  ['All food groups', FoodPreference.AllFoodGroups],
  ['Vegetarian', FoodPreference.Vegetarian],
  ['Vegan', FoodPreference.Vegan],
]);

export const mappedCardioOrResistance = new Map<string, CardioOrResistance>([
  ['Burn', CardioOrResistance.Cardio],
  ['Build', CardioOrResistance.Resistance],
  ['Balance', CardioOrResistance.Balance],
]);
